import React from 'react';
import PropTypes from 'prop-types';
import SelectModalPanel from './SelectModalPanel';

/**
 * SelectKubun
 */
class SelectKubun extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      kubun: this.props.data.kubun,
      masterList: []
    };
    this.handleModalShowChange = this.handleModalShowChange.bind(this);
    this.isModalOpen = false;
    this.itemList = [];
  }


  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedKubun();
  }

  /**
   * 地域・区分選択画面を表示する
   */
  handleModalShowChange(checkedList) {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      if (checkedList != null && checkedList != undefined) {
        this.props.data.kubunIds = checkedList;
      }
      this.setState({ masterList: [] });
      $('#modal_kubun_select_panel').hide();
    } else {
      this.isModalOpen = true;
      this.setState({ masterList: this.itemList });
      $('#modal_kubun_select_panel').show();
    }
  }

  render() {
    let itemList = [];

    // 表示データを取得
    if (this.props.pskubun == null || this.props.pskubun === '') {
      itemList = this.props.data.itemList.kubunList['allList'];
    } else if (this.props.pskubun === '1') {
      itemList = this.props.data.itemList.kubunList['slotList'];
    } else {
      itemList = this.props.data.itemList.kubunList['pachinkoList'];
    }

    this.itemList = itemList;

    let SelectModalPanelNodes = null;
    if (itemList.length != 0) {
      SelectModalPanelNodes = (
        <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'地区'}
          allCheckText={'すべて'}
          checkedList={this.props.data.kubunIds}
          idKey={'id'}
          valueKey={'display_name'}
        />
      );
    }

    return (
      <div>
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
          <p>地域・区分</p>
        </div>
        <label className="select_panel_content_parent" onClick={() => this.handleModalShowChange()}>
          <div id="selectKubun" className="select_kubun_content">
            <p>bbb</p>
          </div>
        </label>

        <div id="modal_kubun_select_panel" className="modal_select_panel">
          {SelectModalPanelNodes}
        </div>

      </div>
    );
  }
}

SelectKubun.propTypes = {
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectKubun;
